var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-wrapper',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"container"},[_c('sc-button',{staticClass:"create-button",attrs:{"variant":"primary"},on:{"click":_vm.downloadFileReport}},[_vm._v("Download Report")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }